import { create } from 'zustand';

type VideoTemplateState = {
  videoIdsToDelete: number[];
  addVideoIdToDelete: (videoId: number) => void;
  resetVideoIdsToDelete: () => void;
};

const useVideoTemplateStore = create<VideoTemplateState>((set) => ({
  videoIdsToDelete: [],
  addVideoIdToDelete: (videoId) => set((state) => ({ videoIdsToDelete: [...state.videoIdsToDelete, videoId] })),
  resetVideoIdsToDelete: () => set({ videoIdsToDelete: [] }),
}));

export default useVideoTemplateStore;
